import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DecorateUntilDestroy } from '@skyeng/libs/shared/rxjs';
import { LocalizeService } from '@localize/localize.service';
import { TranslocoService } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageService } from '@cdk/browser';

interface Language {
  value: string;
  label: string;
  img: string;
}

type Languages = Language[];

const optionsLanguages: Languages = [
  { value: 'ru', label: 'Рус', img: '../../../../../assets/icons/ru.svg' },
  { value: 'en', label: 'Eng', img: '../../../../../assets/icons/gb.svg' },
];

@Component({
  selector: 'crm-header-lang-select',
  templateUrl: './header-lang-select.component.html',
  styleUrls: ['./header-lang-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderLangSelectComponent {
  readonly languages: Languages = optionsLanguages;
  language$: Observable<Language> = this.storage.getItem$('lang').pipe(
    map((lang: string) => {
      return this.languages.find((value: Language) => value.value === lang);
    }),
  );

  constructor(
    private transloco: TranslocoService,
    private localizeService: LocalizeService,
    private storage: LocalStorageService,
  ) {}

  selectLanguage(lang: string): void {
    this.localizeService.changeLanguage(lang);
  }
}
